export const ZpetnyOdkupNd = 'ZpetnyOdkupNd';
